module.exports = __webpack_public_path__ + "img/62c247d.png";